import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { BackofficeErrorFallback, BackofficePage } from '@/pages/BackofficePage'
import { PageLoader } from '@/components/shared/PageLoader'
import { fetchProfiles } from '@/services/api/profiles'
import { requireRoles } from '@/utils/routeGuards.ts'
import { ROUTE_ACCESS } from '@/constants/routeAccess.ts'
import { ROUTES } from '@/constants/routeConstants'

export const profileSearchSchema = z.object({
  offset: z.number().nonnegative().catch(1).optional(),
  sortBy: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
  status: z.string().optional(),
  type: z.string().optional(),
  company: z.string().optional(),
  availability: z.string().optional(),
  registration: z.string().optional(),
  search: z.string().optional(),
})

export const Route = createFileRoute('/backoffice/')({
  beforeLoad: requireRoles(ROUTE_ACCESS[ROUTES.BACKOFFICE]),
  validateSearch: profileSearchSchema,
  loaderDeps: ({
    search: {
      offset,
      sortBy,
      sortOrder,
      status,
      type,
      company,
      availability,
      registration,
      search,
    },
  }) => ({
    offset,
    sortBy,
    sortOrder,
    filters: { status, type, company, availability, registration },
    search,
  }),
  loader: async ({ deps: { offset, sortBy, sortOrder, filters, search } }) =>
    fetchProfiles({ offset, sortBy, sortOrder, filters, search }),
  component: BackofficePage,
  pendingComponent: PageLoader,
  errorComponent: BackofficeErrorFallback,
})
